exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".footer3[data-v-6d05ca9c]{text-align:center;padding-top:17px;padding-bottom:10px;background:#fff}.footer3 p[data-v-6d05ca9c]{font-size:.16rem;margin-top:7px}.fixed-bottom[data-v-6d05ca9c]{position:fixed;bottom:0;width:100%}", "", {"version":3,"sources":["D:/qianduan/ahjgjtMobile/src/components/common/footer.vue"],"names":[],"mappings":"AACA,0BAA0B,kBAAmB,iBAAiB,oBAAoB,eAAgB,CACjG,AACD,4BAA4B,iBAAkB,cAAe,CAC5D,AACD,+BAA+B,eAAgB,SAAU,UAAW,CACnE","file":"footer.vue","sourcesContent":["\n.footer3[data-v-6d05ca9c]{text-align: center;padding-top:17px;padding-bottom:10px;background:#fff;\n}\n.footer3 p[data-v-6d05ca9c]{font-size:0.16rem;margin-top:7px;\n}\n.fixed-bottom[data-v-6d05ca9c]{position: fixed;bottom: 0;width:100%;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6d05ca9c","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/footer.vue
// module id = 359
// module chunks = 3 4 5 9 13 14 15 16 23 24 25 26